$(function () {
  //cookie warning
  $('.cookie-accept').click(function (e) {
    e.preventDefault();
    Cookies.set('cookie-seen', true, { sameSite: 'strict', expires: 5000 });
    $('.cookie-container').removeClass('active');
  });

  const cookiePopup = $('.cookie-container');
  if (cookiePopup && !Cookies.get('cookie-seen')) {
    cookiePopup.addClass("active");
  }
});
